import { OrgRecord } from "../domain/orgs";

const CURRENT_ORG_STORAGE_KEY = "currentOrg";

export const orgStorage = {
  clearCurrentOrg,
  getCurrentOrg,
  setCurrentOrg,
};

/**
 * Clears the current org from the persistent storage.
 */
function clearCurrentOrg() {
  localStorage.removeItem(CURRENT_ORG_STORAGE_KEY);
}

/**
 * Overly simplistic type guard for OrgRecord
 */
function isOrgRecord(obj: unknown): obj is OrgRecord {
  return obj instanceof Object && "org_id" in obj;
}

/**
 * Retrieves the current org from a persistent storage.
 */
function getCurrentOrg(): OrgRecord | null {
  const serializedOrg = localStorage.getItem(CURRENT_ORG_STORAGE_KEY);

  // Validate is of object of type OrgRecord
  if (serializedOrg) {
    try {
      const org: unknown = JSON.parse(serializedOrg);
      if (isOrgRecord(org)) {
        return org;
      }
    } catch {
      // Swallow errors and return null
    }
  }

  return null;
}

/**
 * Saves the current org to a persistent storage.
 */
function setCurrentOrg(org: OrgRecord) {
  localStorage.setItem(CURRENT_ORG_STORAGE_KEY, JSON.stringify(org));
}
